var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTagFacilityIconBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 10H6.00008V11.3333H4.66675V10Z",
    fill: "#4D4D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6608 1.33398H6.00677C5.2661 1.33398 4.66677 1.93332 4.66677 2.67398V6.43198L1.5321 9.52665C1.43818 9.61954 1.37397 9.73824 1.34762 9.86769C1.32128 9.99714 1.33398 10.1315 1.38412 10.2537C1.43427 10.3759 1.51959 10.4805 1.62926 10.5541C1.73893 10.6278 1.868 10.6672 2.0001 10.6673V14.0007C2.0001 14.1775 2.07034 14.347 2.19536 14.4721C2.32039 14.5971 2.48996 14.6673 2.66677 14.6673H13.3334C13.5102 14.6673 13.6798 14.5971 13.8048 14.4721C13.9299 14.347 14.0001 14.1775 14.0001 14.0007V2.67332C14.0001 1.93332 13.4014 1.33398 12.6608 1.33398ZM7.28143 10.0747V13.334H3.33343V9.62198L5.32477 7.65598L7.28143 9.65798V10.0747ZM8.66677 6.00065H7.33343V4.66732H8.66677V6.00065ZM11.3334 11.334H10.0001V10.0007H11.3334V11.334ZM11.3334 8.66732H10.0001V7.33398H11.3334V8.66732ZM11.3334 6.00065H10.0001V4.66732H11.3334V6.00065Z",
    fill: "#F56600"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagFacilityIconBuilding);
export default __webpack_public_path__ + "static/media/Tag-Facility-icon-building.9556517f13299b230d7bf6f2838f36e6.svg";
export { ForwardRef as ReactComponent };